import React from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import { Container, Row, Col } from 'reactstrap';
import LearningFilter from '../Common/LearningFilter';
import BlogBox from './BlogBox';
import BoxList from './BoxList';

const LearningListContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Learning List' parent='Learning' title='Learning List' />
      <Row className='learning-block'>
        <Col xxl='9' xl='8' className='box-col-8'>
          <Row>
            <BlogBox />
            <BoxList />
          </Row>
        </Col>
        <LearningFilter />
      </Row>
    </Container>
  );
};

export default LearningListContainer;
